import React from 'react'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import Progress from '_components/ProgressBar'
import { HStack, Box, Spacer } from '@chakra-ui/react'

function UsageCard({ title, limit, used }) {
  let remaining = limit - used
  if(remaining < 0) remaining = 0
  const format = limit >= 10000 ? '0.[00]a' : '0,0'

  return (
    <Box w="full" px="4" pt="2" pb="3">
      <Box fontSize="xs" fontWeight="bold" mb="1">
        {title}
      </Box>
      <HStack color="brand.muted" align="baseline" spacing="1" mb="1">
        <Box fontSize="sm" fontWeight="bold" color="brand.text" title={used}>{numeral(used).format(format)}</Box>
        <Box fontSize="2xs" textTransform="uppercase">used</Box>
        <Spacer />
        <Box fontSize="sm" fontWeight="bold" color="brand.text" title={remaining}>{numeral(remaining).format(format)}</Box>
        <Box fontSize="2xs" textTransform="uppercase">remaining</Box>
      </HStack>
      <Progress size="xs" completion value={used || 1} max={Math.max(limit, used)} />
    </Box>
  )
}

UsageCard.propTypes = {
  title: PropTypes.string.isRequired,
  limit: PropTypes.number,
  used: PropTypes.number,
  className: PropTypes.string
}
export default UsageCard
